/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   7/28/21
 */

import countryNames from "../const/country-names";
import {Employee, EmployeesGroupBySetting} from "../interfaces/Global";

const NOT_APPLICABLE = "N/A";
const NO_TAGS_TITLE = "Not Tagged";

export const getGroupTitles = (employees: Employee[], groupBy: Exclude<EmployeesGroupBySetting, "off">, filterTags: string[]) => {
	let groupTitles: string[] = [];
	employees.forEach(employee => {
		if (groupBy === "tags") {
			let tagged = false;
			if (filterTags.length > 0) {
				filterTags.forEach(t => {
					if (employee.tags?.some(et => et === t)) {
						groupTitles.push(t);
						tagged = true;
					}
				})
			} else {
				employee.tags?.forEach(tag => {
					if (!groupTitles.includes(tag)) {
						groupTitles.push(tag);
						tagged = true;
					}
				});
			}
			if (!tagged && !groupTitles.includes(NO_TAGS_TITLE)) {
				groupTitles.push(NO_TAGS_TITLE);
			}
		} else {
			let groupTitle = NOT_APPLICABLE;
			if (groupBy === "manager") groupTitle = employee.manager?.displayName || NOT_APPLICABLE;
			else if (groupBy === "country") {
				if (employee.countryCode) groupTitle = (countryNames as Record<string, string>)[employee.countryCode];
			}
			else if (employee[groupBy]) groupTitle = employee[groupBy] || NOT_APPLICABLE;
			if (!groupTitles.includes(groupTitle)) {
				groupTitles.push(groupTitle);
			}
		}
	});
	return groupTitles;
}

export const getEmployeeGroups = (groupTitles: string[], employees: Employee[], groupBy: Exclude<EmployeesGroupBySetting, "off">) => {
	let groups: Record<string, Employee[]> = {};
	groupTitles.forEach(title => {
		groups[title] = employees.filter(employee => {
			if (groupBy === "manager") {
				return (employee.manager?.displayName || NOT_APPLICABLE) === title;
			} else if (groupBy === "country") {
				return ((countryNames as Record<string, string>)[employee.countryCode ?? ""] || NOT_APPLICABLE) === title;
			} else if (groupBy === "tags") {
				if (title === NO_TAGS_TITLE) {
					return !employee.tags || employee.tags.length === 0 || employee.tags.every(t => !groupTitles.includes(t))
				}
				return employee.tags?.some(tag => tag === title);
			} else if (employee[groupBy]) {
				return (employee[groupBy] || NOT_APPLICABLE) === title;
			}
			return false;
		});
	});
	return groups;
}